// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__2lgkF","signup":"Button_signup__2ELen"};